import DynamicOverview from '@/modules/integrations/types/dynamicpromotions/DynamicOverview'
import DynamicSettings from '@/modules/integrations/types/dynamicpromotions/DynamicSettings'
import DynamicPromotions from '@/modules/integrations/types/dynamicpromotions/DynamicPromotions'
import DynamicPromotionsSyncDialog from '@/modules/integrations/types/dynamicpromotions/DynamicPromotionsSyncDialog'

export default Object.freeze({
  type: 'dynamicpromotions',
  title: 'Promotions Integration',
  category: 'Integrations_Dynamic_Promotions_Category',
  description: 'Integrations_Dynamic_Description',
  requiresAdmin: false,
  components: {
    overview: DynamicOverview,
    settings: DynamicSettings,
    promotions: DynamicPromotions
  },
  actions: [
    {
      icon: 'el-icon-refresh',
      label: 'Integrations_DynamicPromotions_Action_Sync',
      dialog: DynamicPromotionsSyncDialog,
      disabled_path: 'params.sync_enabled'
    }
  ],
  urls: {
    guide: 'https://docs.xtremepush.com/docs/third-party-integrations'
  }
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/dynamicpromotions/index.js